import * as angular from 'angular';
import {
    embedded,
    hideModalBackground,
    showModalBackground
} from 'angular/utils/config';

export interface ConfirmModal {
    (text: string, title?: string): angular.ui.bootstrap.IModalInstanceService;
}

function getConfirmModalInstance($uibModal): ConfirmModal {
    return (
        text: string,
        title: string = 'Are you sure?'
    ): angular.ui.bootstrap.IModalInstanceService => {
        return $uibModal.open({
            template: `
<div class="modal-content">
    <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="$dismiss(null)">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">${title}</h4>
    </div>
    <div class="modal-body">
        ${text}
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" ng-click="$dismiss(null)">
            No, I do not want to.
        </button>
        <button type="button" class="btn btn-primary" ng-click="$close(true)">
            Yes, I want to.
        </button>
    </div>
</div>
`,
            controller: ($scope, $uibModalInstance) => {
                integrateUibModelInReact($scope, $uibModalInstance);
            }
        });
    };
}

angular.module('app').factory('confirmModal', getConfirmModalInstance);

// https://angular-ui.github.io/bootstrap/#modal
export function integrateUibModelInReact(
    $scope,
    $uibModalInstance: angular.ui.bootstrap.IModalInstanceService
) {
    if (!embedded) return;

    $uibModalInstance.rendered.then(() => window.parent.scrollTo(0, 0));

    const reactBody = window.parent.document.body;
    showModalBackground();

    const onReactClick = () => $uibModalInstance.dismiss(null);
    reactBody.addEventListener('click', onReactClick);

    $scope.$on('modal.closing', (event, reason, closed) => {
        hideModalBackground();
        reactBody.removeEventListener('click', onReactClick);
    });
}
